export const pages = {
    results: ['/app/results', '/results'],
    holiday: ['/app/holiday', '/holiday']
}